<template>
  <div class="app-container">
    <el-card class="box-card">
      <div class="filter-container">
        <el-form :model="query" ref="queryForm" :inline="true">
          <el-form-item label="订单编号：">
            <el-input v-model="query.ordernum" placeholder="请输入订单编号" clearable size="small" />
          </el-form-item>
          <el-form-item label="订单类型：">
            <el-select v-model="query.type" placeholder="全部" clearable size="small">
              <el-option label="全部" :value="undefined" />
              <el-option 
                v-for="(item, key) in orderTypeMap" 
                :key="key"
                :label="item.label" 
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="下单人：">
            <el-input v-model="query.nameorpho" placeholder="请输入姓名/手机号" clearable size="small" />
          </el-form-item>
          <el-form-item label="下单人身份：">
            <el-select v-model="query.levelId" placeholder="请选择" clearable size="small">
              <el-option :label="it.name" :value="it.level" v-for="it in fetchList" :key="it.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="订单状态：">
            <el-select v-model="query.state" placeholder="全部" clearable size="small">
              <el-option label="全部" :value="undefined" />
              <el-option label="已支付" :value="1" />
              <el-option label="已取消" :value="2" />
            </el-select>
          </el-form-item>
          <el-form-item label="支付方式：">
            <el-select v-model="query.payType" placeholder="全部" clearable size="small">
              <el-option label="全部" :value="undefined" />
              <el-option label="支付宝" :value="1" />
              <el-option label="微信支付" :value="2" />
              <el-option label="支付凭证" :value="3" />
              <el-option label="银行卡" :value="4" />
              <el-option label="组合现金支付" :value="0" />
            </el-select>
          </el-form-item>
          <el-form-item label="业务信息：">
            <el-input v-model="query.ywName" placeholder="请输入姓名/手机号" clearable size="small" />
          </el-form-item>

          <el-form-item label="大区信息：">
            <el-input v-model="query.areaName" placeholder="请输入姓名/手机号" clearable size="small" />
          </el-form-item>
          <el-form-item label="客户状态：">
            <el-select v-model="query.isOneselfDeveloped" placeholder="全部" clearable size="small">
              <el-option label="全部" :value="undefined" />
              <el-option label="开发客户" :value="1" />
              <el-option label="继承客户" :value="0" />
            </el-select>
          </el-form-item>
          <el-form-item label="下单时间：">
            <el-date-picker v-model="dateTime" size="small" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss" start-placeholder="开始" end-placeholder="结束" />
          </el-form-item>
          <el-form-item label="支付成功时间：">
            <el-date-picker v-model="payTime" size="small" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss" start-placeholder="开始" end-placeholder="结束" />
          </el-form-item>
          <el-form-item class="fr">
            <el-button type="primary" @click="handleQuery" size="mini">搜索</el-button>
            <el-button type="info" @click="handleFilter" plain size="mini">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <el-card class="box-card mt10">
      <div class="btn-right-side mb10">
        <div class="btn-box">
          <el-button type="primary" size="mini" @click="handleDownload" plain>导出</el-button>
        </div>
      </div>
      <el-table class="reward-report-table" v-loading="listLoading" :data="list" @sort-change="sortChange">
        <el-table-column label="订单编号" prop="ordernum" align="center" min-width="220" class-name="reward-number-column" fixed />
        <el-table-column label="订单类型" prop="type" align="center">
          <template slot-scope="{row}">
            {{ getOrderTypeLabel(row.type) }}
          </template>
        </el-table-column>
        <el-table-column label="收款类型" prop="receiptType" align="center" min-width="160" />
        <el-table-column label="客户用友编码" prop="customerCode" align="center" min-width="140" />
        <el-table-column label="下单人信息" prop="name" align="center">
          <template slot-scope="{row}">
            {{ row.name }}
            <span v-if="row.pho">({{ row.pho }})</span>
          </template>
        </el-table-column>

        <el-table-column label="下单人身份" prop="levelName" align="center" />
        <el-table-column label="所属区域" prop="area" align="center" />
        <el-table-column label="订单状态" prop="state" align="center">
          <template slot-scope="{row}">
            {{ row.state === 1?'已支付':(row.state === 2?'已取消':'') }}
          </template>
        </el-table-column>
        <el-table-column label="下单时间" prop="createdTime" align="center" min-width="180" class-name="reward-date-column">
          <template slot-scope="{row}">{{ recordedValue(row.createdTime) }}</template>
        </el-table-column>
        <el-table-column label="订单总金额" prop="orderMoney" align="center" />
        <el-table-column label="支付方式" prop="payType" align="center">
          <template slot-scope="{row}">
            {{ cashPaymentLabel(row.payType) }}
          </template>
        </el-table-column>
        <el-table-column label="现金支付金额（不含运费）" prop="payMoney" align="center" min-width="190" />
        <el-table-column label="运费" prop="freight" align="center" />
        <el-table-column label="通商云单号" prop="tongShangYunOrderNum" align="center" min-width="220" class-name="reward-payment-column">
          <template slot-scope="{row}">{{ recordedValue(row.tongShangYunOrderNum, '—') }}</template>
        </el-table-column>
        <el-table-column label="支付单号" prop="payOrderNum" align="center" min-width="240" class-name="reward-payment-column">
          <template slot-scope="{row}">{{ offlinePaymentNumbers(row) }}</template>
        </el-table-column>
        <el-table-column label="收款银行" prop="receiptBank" align="center" min-width="180" class-name="reward-payment-column">
          <template slot-scope="{row}">{{ recordedValue(row.receiptBank, '—') }}</template>
        </el-table-column>
        <el-table-column label="城市公司名称" prop="cityCompanyName" align="center" min-width="140">
          <template slot-scope="{row}">{{ recordedValue(row.cityCompanyName) }}</template>
        </el-table-column>
        <el-table-column label="充值类型" prop="rechargeType" align="center" min-width="140">
          <template slot-scope="{row}">{{ recordedValue(row.rechargeType, '—') }}</template>
        </el-table-column>
        <el-table-column label="客户状态" prop="isOneselfDeveloped" align="center">
          <template slot-scope="{row}">
            {{ row.isOneselfDeveloped === 1?'开发客户':(row.isOneselfDeveloped === 0?'继承客户':'未记录') }}
          </template>
        </el-table-column>
        <el-table-column label="业务员信息" prop="ywName" align="center" min-width="180">
          <template slot-scope="{row}">{{ recordedValue(row.ywName) }}</template>
        </el-table-column>
        <el-table-column label="营销经理姓名" prop="marketingManagerName" align="center" min-width="120">
          <template slot-scope="{row}">{{ recordedValue(row.marketingManagerName) }}</template>
        </el-table-column>
        <el-table-column label="大区信息" prop="areaName" align="center" min-width="140">
          <template slot-scope="{row}">{{ recordedValue(row.areaName) }}</template>
        </el-table-column>
        <el-table-column label="大区入职时间" prop="isareatime" align="center" min-width="180" class-name="reward-date-column" show-overflow-tooltip>
          <template slot-scope="{row}">{{ recordedValue(row.isareatime) }}</template>
        </el-table-column>
        <!-- <el-table-column label="是否转正" prop="isRegularName" align="center" /> -->
        <!-- <el-table-column label="转正时间" prop="createdTime" align="center" /> -->
        <el-table-column label="佣金比例" prop="incomeRatio" align="center">
          <template slot-scope="{row}">
            {{ recordedValue(row.incomeRatio) === '未记录' ? '未记录' : row.incomeRatio + '%' }}
          </template>
        </el-table-column>
        <el-table-column label="佣金金额" prop="incomeMoney" align="center">
          <template slot-scope="{row}">{{ recordedValue(row.incomeMoney) }}</template>
        </el-table-column>
      </el-table>
      <pagination v-show="total>0" :total="total" :pageNo.sync="query.pageNo" :pageSize.sync="query.pageSize" @pagination="doQueryList" />
    </el-card>
  </div>
</template>

<script>
import OrderPerformanceApi from '@/api/order/OrderPerformance'
import Pagination from '@/components/Pagination'
import goodsOrderApi from '@/api/order/goodsOrder'
import enums from '@/utils/enums'
import { performanceFilters } from '@/utils/orderPerformance'
import { cashPaymentLabel } from '@/utils/order-cash-report'
export default {
  components: {
    Pagination,
  },
  data() {
    return {
      list: [],
      total: 0,
      listLoading: true,
      query: {
        pageNo: 1,
        pageSize: 10,
      },
      dateTime: [],
      payTime: [],
      fetchList: []

    }
  },
  created() {
    this.doQueryList({ pageNo: 1 })
    this.getFetchList()
  },
  computed: {
    orderTypeMap() {
      return enums.getOrderType()
    }
  },
  methods: {
    cashPaymentLabel,
    recordedValue(value, fallback = '未记录') {
      return value === undefined || value === null || String(value).trim() === '' ? fallback : value
    },
    offlinePaymentNumbers(row) {
      return row.type === 4 || row.type === 5 ? (row.payOrderNum || '') : ''
    },
    // 获取订单类型标签
    getOrderTypeLabel(type) {
      return enums.findEnumLabel(type, this.orderTypeMap) || '未知类型'
    },
    getFetchList() {
      goodsOrderApi.fetchList({}).then((data) => {
        this.fetchList = data.data;
      })
    },
    handleFilter() {
      this.query = { pageNo: 1, pageSize: 10 }
      this.dateTime = []
      this.payTime = []
      this.doQueryList({ pageNo: 1, pageSize: 10 })
    },
    /**
     * 触发后端排序
     */
    sortChange({ prop, order }) {
      const sortKeyMap = {
        'orderTime': 'orderTimeSortSign',
        'joinRegionTime': 'joinRegionTimeSortSign',
        'regularTime': 'regularTimeSortSign'
      }
      for (var k in sortKeyMap) {
        const sortKey = sortKeyMap[k]
        if (k !== prop) {
          this.query[sortKey] = null
        } else {
          if (order === 'ascending') {
            this.query[sortKey] = 1
          } else {
            this.query[sortKey] = -1
          }
        }
      }
      this.doQueryList({})
    },
    /**
     * 触发搜索操作
     */
    handleQuery() {
      this.doQueryList({ pageNo: 1 })
    },
    /**
     * 执行列表查询
     */
    doQueryList({ pageNo, pageSize }) {
      if (pageNo) {
        this.query.pageNo = pageNo
      }
      if (pageSize) {
        this.query.pageSize = pageSize
      }
      this.query.timeType = 0
      this.query.startTime = this.dateTime && this.dateTime.length > 0 ? this.dateTime[0] : undefined
      this.query.endTime = this.dateTime && this.dateTime.length > 0 ? this.dateTime[1] : undefined
      this.query.payStartTime = this.payTime && this.payTime.length > 0 ? this.payTime[0] : undefined
      this.query.payEndTime = this.payTime && this.payTime.length > 0 ? this.payTime[1] : undefined
      this.listLoading = true
      return OrderPerformanceApi.performanceList(this.query)
        .then(data => {
          this.list = data.data.list
          this.total = data.data.total
        })
        .finally(() => {
          this.listLoading = false
        })
    },
    handleDownload() {
      const filters = performanceFilters({
        ...this.query,
        timeType: 0,
        startTime: this.dateTime && this.dateTime[0],
        endTime: this.dateTime && this.dateTime[1],
        payStartTime: this.payTime && this.payTime[0],
        payEndTime: this.payTime && this.payTime[1]
      })
      this.$router.push({
        path: '/export/list',
        query: { code: 'OrderPerformanceExport', performanceFilters: JSON.stringify(filters) }
      })
    },
    handleLog(row) {
      this.$router.push("/log/log?type=23&id=" + row.id);
    }
  }
}
</script>
<style scoped>
::v-deep .reward-date-column .cell {
  white-space: nowrap;
  word-break: normal;
}
::v-deep .reward-number-column .cell {
  white-space: nowrap;
  word-break: normal;
}
::v-deep .reward-payment-column .cell {
  white-space: pre-line;
  word-break: normal;
}
::v-deep .reward-report-table .el-table__empty-block {
  width: 100% !important;
  position: sticky;
  left: 0;
}
</style>
